import { render, staticRenderFns } from "./UserPhoneBindPart.vue?vue&type=template&id=162be3f2&scoped=true&"
import script from "./UserPhoneBindPart.vue?vue&type=script&lang=js&"
export * from "./UserPhoneBindPart.vue?vue&type=script&lang=js&"
import style0 from "./UserPhoneBindPart.vue?vue&type=style&index=0&id=162be3f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162be3f2",
  null
  
)

export default component.exports